import { Injectable } from '@angular/core';
import { getRegExpToUse } from '@app/shared/components/catalog/services/filters.service.ts';

@Injectable()
export class MappingServiceHash {
  private dataFormated = {};
  private facetNotReformated = ['brand.facet'];

  constructor() {}

  init(currentValue) {
    this.formateDataFromAloglia(currentValue);
  }

  formateDataFromAloglia(algoliaResult) {
    for (const facet in algoliaResult) {
      if (!this.facetNotReformated.includes(facet)) {
        this.dataFormated[facet] = {};
        for (const value in algoliaResult[facet]) {
          if (value) {
            const regexp = getRegExpToUse(value.split('#').length === 3);
            const match = value.match(regexp);
            if (match) {
              this.dataFormated[facet][parseInt(match[2], 10)] = {
                label: value,
                hitsNumber: algoliaResult[facet][value]
              };
            }
          }
        }
      }
    }
    this.storeInTransfertState(this.dataFormated);
  }

  storeInTransfertState(dataToTransfertState) {
    // this.transferState.set(makeStateKey<number>('mappingFilterForHash'), dataToTransfertState);
  }
}
